import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environment/environment';

/**
 * Auth Interceptor que usa cookies.
 * - Cookies se envían automáticamente por el navegador cuando withCredentials: true.
 * - Se aplica a todas las APIs internas listadas abajo.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const internalApiPrefixes = [
    environment.BASE_API,
    environment.API_AUTH,
    environment.API_AUTH_LOGIN,
    environment.API_ARIA_CORE,
    environment.CUSTOMER_API,
    environment.ORDERS_API,
    environment.UBIGEO_API,
    environment.API_FILE_MANAGER,
  ].filter(Boolean);

  const isInternalApi = internalApiPrefixes.some(prefix =>
    prefix && req.url.startsWith(prefix)
  );

  if (!isInternalApi) {
    return next(req);
  }

  const headers: Record<string, string> = {
    'x-requested-by': 'aria-web'
  };

  const authReq = req.clone({
    withCredentials: true,
    setHeaders: headers
  });

  return next(authReq);
};
